import { useRouter } from "next/router";

import type { SangjoReviewTag } from "@/types/reviewType";

export const useReviewPageRouter = () => {
  const router = useRouter();
  const { page, tag } = router.query as {
    page?: string;
    tag?: SangjoReviewTag extends SangjoReviewTag ? SangjoReviewTag : string;
  };

  const setReviewPageNum = (newPage: number) => {
    const nextRouter = { ...router };
    /** 나머지 쿼리들은 그대로 가져감 page만 변경 */
    nextRouter.query.page = newPage.toString();
    router.push(nextRouter);
  };

  const getReviewTagPageHref = (tagName?: string) => {
    return tagName ? `/review/tag/${tagName}` : "/review";
  };

  return {
    router,
    page,
    tag,
    getReviewTagPageHref,
    setReviewPageNum,
  };
};
